import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';

class IVRService extends ServiceCRUD {
  constructor() {
    super('/api/uras');
  }
}

export default new IVRService();
